"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownMenuItem = exports.DropdownMenu = exports.DropdownContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var DropdownContainer = exports.DropdownContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n"])));
var DropdownMenu = exports.DropdownMenu = _styledComponents["default"].ul(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: var(--color-neutral-70);\n  box-shadow: var(--shadow-level-6);\n  border-radius: var(--border-radius-sm);\n  z-index: var(--z-index-700-overlay);\n  position: absolute;\n  top: 100%;\n  list-style: none;\n  width: 150px;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var position = _ref.position;
  return position === 'right' && "\n      left: 0;\n  ";
}, function (_ref2) {
  var position = _ref2.position;
  return position === 'left' && "\n      right: 0;\n  ";
});
var DropdownMenuItem = exports.DropdownMenuItem = _styledComponents["default"].li(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-family: var(--font-family);\n  font-size: var(--font-size-xxs);\n  font-weight: var(--font-weight-regular);\n  font-style: normal;\n  padding: var(--spacing-2);\n  word-break: break-word;\n  width: 100%;\n  cursor: pointer;\n\n  &:hover {\n    background-color: var(--color-neutral-90);\n  }\n"])));